// NOTE: Enum keys must match the ones in translation file
export enum SmsMacroType {
  END_USER_PHONE_NUMBER = 'END_USER_PHONE_NUMBER',
  TEMP_END_USER_PHONE_NUMBER = 'TEMP_END_USER_PHONE_NUMBER',
  NEW_END_USER_PHONE_NUMBER = 'NEW_END_USER_PHONE_NUMBER',
  PLAN_NAME = 'PLAN_NAME',
  PLAN_DURATION = 'PLAN_DURATION',
  PLAN_DURATION_TRIGGER = 'PLAN_DURATION_TRIGGER',
  PLAN_CAPACITY = 'PLAN_CAPACITY',
  PLAN_FINAL_PRICE = 'PLAN_FINAL_PRICE',
  PLAN_FINAL_PRICE_CURRENCY = 'PLAN_FINAL_PRICE_CURRENCY',
  PURCHASE_DATE = 'PURCHASE_DATE',
  DATA_THRESHOLD_PERCENTAGE = 'DATA_THRESHOLD_PERCENTAGE',
  INITIAL_DATA = 'INITIAL_DATA',
  CONSUMED_DATA = 'CONSUMED_DATA',
  REMAINING_DATA = 'REMAINING_DATA',
  TIME_THRESHOLD_PERCENTAGE = 'TIME_THRESHOLD_PERCENTAGE',
  REMAINING_DURATION = 'REMAINING_DURATION',
  EXPIRATION_DATE = 'EXPIRATION_DATE',
  NEW_PLAN_NAME = 'NEW_PLAN_NAME',
  NEW_PLAN_FINAL_PRICE = 'NEW_PLAN_FINAL_PRICE',
  NEW_PLAN_FINAL_PRICE_CURRENCY = 'NEW_PLAN_FINAL_PRICE_CURRENCY',
  PAYMENT_CHANNEL = 'PAYMENT_CHANNEL',
  REFERENCE_NUMBER = 'REFERENCE_NUMBER',
}
